import React from 'react';
import { SpaceAssetsSelectorModalWrapper } from './component/SpaceAssetsSelectorModal';
import { QueryBuilderProvider } from './component/SpaceAssetsSelectorModal/context/QueryBuilderContext';

const AMV2AssetSelector = (props) => {
  return (
    <QueryBuilderProvider>
      <SpaceAssetsSelectorModalWrapper {...props} />
    </QueryBuilderProvider>
  );
};

export default AMV2AssetSelector;
